module.exports = __webpack_public_path__ + "static/10-9246750e405541353dc2fd6f3132bd95.jpg";